module.exports = "/_next/static/images/label-799fdad9112d7ea65e8592a03424b508.svg";